import * as yup from "yup";

/**
 * Stara lozinka se ne traži: ovo radi naše osoblje kad korisnik ostane bez pristupa, a ne
 * korisnik sam. Potvrda ostaje, jer se lozinka nakon spremanja nigdje ne može pročitati.
 */
export const USER_PASSWORD_FORM_SCHEMA = yup.object().shape({
  password: yup
    .string()
    .nullable()
    .required("Molimo Vas da unesete lozinku")
    .min(6, "Lozinka mora imati barem 6 znakova"),
  confirmPassword: yup
    .string()
    .nullable()
    .required("Molimo Vas da ponovite lozinku")
    .oneOf([yup.ref("password")], "Lozinke se ne podudaraju"),
});
